import { Base } from '@studiometa/js-toolkit';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);

/**
 * ScreenInfo component
 */
export default class ScreenInfo extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ScreenInfo',
    options: {
      name: {
        type: String,
        default: '',
      },
      endMobile: {
        type: String,
        default: 'bottom 300px',
      },
      end: {
        type: String,
        default: 'bottom 300px',
      },
    },
  };

  breakpoints = ['xxs', 'xs'];

  /**
   * Get isMobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }

  /**
   * mounted
   */
  mounted() {
    let end = this.$options.end;
    if (this.isMobile && this.$options.endMobile) {
      end = this.$options.endMobile;
    }

    gsap.to(this.$el, {
      opacity: 1,
      zIndex: 2,
      duration: 1,
      ease: 'power4.inOut',
      scrollTrigger: {
        trigger: `#${this.$options.name}`,
        toggleActions: 'play reverse play reverse',
        end,
      },
    });
  }
}
